export default "__VITE_ASSET__5YAS5RQC__"